/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useHistory } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

const FlaggedViewSalesLogBtn = () => {
  const history = useHistory();
  const flags = useFlags();

  return (
    flags.salesLogLink && (
      <span
        className="blue-link pointer m-right-24 fw-500 fs-13"
        onClick={() => history.push('/Configuration/sales-triggers/sales-history')}
      >
        View Sales Log
      </span>
    )
  );
};
export default FlaggedViewSalesLogBtn;
